import { Injectable, Type, inject } from '@angular/core';

import { BettingInsightsMarketOptions } from '@cds/betting-offer/betting-insights';
import { EventOption, EventParticipantImage } from '@frontend/sports/betting-offer/feature/model';
import { LoggerFactory } from '@frontend/sports/common/core/feature/logging';
import { ComponentLoaderService, ComponentProxy } from '@frontend/sports/deferred/feature/component-loader';
import { ModuleLoaderService } from '@frontend/sports/deferred/feature/module-loader';

import { BettingInsightsModule } from './betting-insights.module';

export interface BettingInsightsBindingModel {
    bettingInsightsMarketOptions: BettingInsightsMarketOptions[];
    optionRows: ISixPackOptionRow[];
    sportId: number;
}
export interface ISixPackOptionRow {
    player: string;
    columns: Map<number, EventOption | null>;
    playerImage?: EventParticipantImage;
    playerId?: number;
}

@Injectable({ providedIn: 'root' })
export class BettingInsightsComponentLoaderService extends ComponentLoaderService<BettingInsightsModule> {
    moduleName = 'BettingInsightsModule';

    constructor() {
        const moduleLoader = inject(ModuleLoaderService);
        const loggerFactory = inject(LoggerFactory);

        super(moduleLoader, loggerFactory);
    }

    getModule(): Promise<Type<BettingInsightsModule>> {
        return import('./betting-insights.module').then((m) => m.BettingInsightsModule);
    }

    getBettingInsightsComponent(): ComponentProxy<BettingInsightsBindingModel> {
        return this.getComponentProxy((module) => module.bettingInsightsComponent);
    }
}
